import {
  FormikInitialValuesNewRequest,
  NewRequestState,
} from "../model/form.model";

// → “o que o usuário vê/edita nos campos”. | campos editaveis do formulario
export const initialValuesNewRequest: FormikInitialValuesNewRequest = {
  purchase: {
    customerCnpj: "",
    customerName: "",
    deliveryAddressId: "",
    postalCode: "",
    district: "",
    cityState: "",
    freightType: "CIF",
    withdrawBasisId: "",
    branchName: "",
    deliveryDate: "",
    responsibleName: "",
    responsiblePhone: "",
    responsibleEmail: "",
  },
  observation: {
    observationNote: "",
    commentsInInvoice: false,
  },
};

// → “o que a feature precisa para funcionar” (cache, opções, loading, erro, dados carregados da API).
export const initialNewRequestState: NewRequestState = {
  purchase: {
    customer: undefined,
    customersOptions: [],
    availableDates: null,

    loadingCustomer: false,
    loadingDates: false,

    error: undefined,
  },

  products: {
    cart: [],
    pricingStatus: "idle",
    totalPrice: null,
    error: undefined,
  },

  lastPayment: null,
};
